document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('one-up-search');
  const sizeCheckboxes = document.querySelectorAll('.one-up-size-checkbox');
  const colourCheckboxes = document.querySelectorAll('.one-up-colour-checkbox');
  const inStockToggle = document.getElementById('one-up-in-stock-only');
  const resetBtn = document.getElementById('one-up-reset');
  const filterToggle = document.getElementById('one-up-filter-toggle');
  const sidebarFilters = document.getElementById('sidebar-filters');

  // MOBILE FILTER TOGGLE
  if (filterToggle && sidebarFilters) {
    filterToggle.addEventListener('click', function() {
      sidebarFilters.classList.toggle('is-active');
    });
  }

  function filterRows() {
    const searchTerm = searchInput ? searchInput.value.toLowerCase().trim() : '';
    const checkedSizes = Array.from(document.querySelectorAll('.one-up-size-checkbox:checked')).map(cb => cb.value);
    const checkedColours = Array.from(document.querySelectorAll('.one-up-colour-checkbox:checked')).map(cb => cb.value);
    const inStockOnly = inStockToggle ? inStockToggle.checked : false;

    const variantRows = document.querySelectorAll('.variant-row');
    const productHeaders = document.querySelectorAll('.product-header-row');

    variantRows.forEach(row => {
      const rowColour = row.getAttribute('data-variant-colour');
      const rowSize = row.getAttribute('data-variant-size');
      const isOutOfStock = row.classList.contains('is-out-of-stock');
      const matchesSearch = row.getAttribute('data-search-string').includes(searchTerm);
      
      const matchesColour = checkedColours.length === 0 || checkedColours.includes(rowColour);
      const matchesSize = checkedSizes.length === 0 || checkedSizes.includes(rowSize);
      const matchesStock = !inStockOnly || !isOutOfStock;
      
      if (matchesSearch && matchesColour && matchesSize && matchesStock) {
        row.style.display = '';
      } else {
        row.style.display = 'none';
      }
    });

    productHeaders.forEach(header => {
      const pid = header.getAttribute('data-product-id');
      const hasVisible = document.querySelectorAll(`.variant-row[data-product-id="${pid}"]:not([style*="display: none"])`).length > 0;
      header.style.display = hasVisible ? '' : 'none';
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      if (searchInput) searchInput.value = '';
      if (inStockToggle) inStockToggle.checked = false;
      sizeCheckboxes.forEach(cb => cb.checked = false);
      colourCheckboxes.forEach(cb => cb.checked = false);
      filterRows();
    });
  }

  if (searchInput) searchInput.addEventListener('input', filterRows);
  if (inStockToggle) inStockToggle.addEventListener('change', filterRows);
  sizeCheckboxes.forEach(cb => cb.addEventListener('change', filterRows));
  colourCheckboxes.forEach(cb => cb.addEventListener('change', filterRows));

  const qtyInputs = document.querySelectorAll('.one-up-qty-input');
  
  qtyInputs.forEach(input => {
    input.addEventListener('change', function() {
      const variantId = this.dataset.variantId;
      const customPrice = this.dataset.customPrice.replace(/[£,]/g, '');
      const maxInv = parseInt(this.dataset.inventory, 10) || 0;
      let qty = parseInt(this.value, 10) || 0;

      if (qty > maxInv) {
        alert(`Stock limit reached. Setting quantity to ${maxInv}.`);
        qty = maxInv;
        this.value = maxInv;
      }

      this.disabled = true;
      this.style.opacity = '0.5';

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId.toString(), quantity: 0 })
      })
      .then(() => {
        if (qty > 0) {
          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: qty, properties: { "dealerPricing": customPrice } }]
            })
          });
        } else {
          return fetch(window.Shopify.routes.root + 'cart.js');
        }
      })
      .then(response => response.json())
      .then(() => fetch(window.Shopify.routes.root + 'cart.js'))
      .then(res => res.json())
      .then(cart => {
        const cartCountBubble = document.getElementById('CartCount');
        const cartCountSpan = document.querySelector('[data-cart-count]');

        // 1. Update the actual text number
        if (cartCountSpan) {
          cartCountSpan.textContent = cart.item_count;
        }

        // 2. Handle Bubble Visibility
        if (cartCountBubble) {
          if (cart.item_count > 0) {
            // Remove ANY potential hide classes your theme might use
            cartCountBubble.classList.remove('critical-hidden', 'hide', 'hidden');
       
          } else {
            cartCountBubble.classList.add('critical-hidden');
            cartCountBubble.style.display = 'none';
          }
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        this.disabled = false;
        this.style.opacity = '1';
      })
      .catch(err => {
        console.error('Cart Error:', err);
        this.disabled = false;
        this.style.opacity = '1';
      });
    });
  });
});